import './bootstrap';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
// Header template search component factory (window.ltMobileTemplateSearch);
// must be registered before Alpine.start() evaluates the nav's x-data.
import './template-search';

window.Alpine = Alpine;

// Register the collapse plugin
Alpine.plugin(collapse);

Alpine.start();
